import { Card, styled } from "@mui/material";

export const SettingsCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2.25, 2.5),
}));
